import React from 'react';
import { ChatMessage } from '../../types/IAiConversation';
import MarkdownContent from './MarkdownContent';
import DebugBlock from './DebugBlock';
import ChatError from './ChatError';
import FileChip from './FileChip';
import ScheduleChip from './ScheduleChip';

interface IProps {
  message: ChatMessage;
  canRetry: boolean;
  onRetry?: () => void;
}

const ChatBubble = ({ message, canRetry, onRetry }: IProps) => {
  if (message.role === 'user') {
    return <div className="chat-msg chat-msg--user">{message.content}</div>;
  }

  return (
    <div className="chat-msg chat-msg--assistant chat-msg--md">
      {message.content && message.streaming ? (
        <div className="chat-md chat-md--plain">{message.content}</div>
      ) : null}
      {message.content && !message.streaming ? (
        <MarkdownContent content={message.content} />
      ) : null}
      {message.files?.length ? (
        <div className="chat-files">
          {message.files.map((f) => (
            <FileChip key={f.id} file={f} />
          ))}
        </div>
      ) : null}
      {message.schedules?.length ? (
        <div className="chat-files">
          {message.schedules.map((s) => (
            <ScheduleChip key={s.id} schedule={s} />
          ))}
        </div>
      ) : null}
      {message.debug?.length ? <DebugBlock items={message.debug} /> : null}
      {message.error ? (
        <ChatError
          error={message.error}
          canRetry={canRetry}
          onRetry={onRetry}
        />
      ) : null}
    </div>
  );
};

export default ChatBubble;
